import { ChangeDetectionStrategy, Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'meeting-actions-modal',
  templateUrl: './meeting-actions-modal.component.html',
  styleUrls: ['./meeting-actions-modal.component.scss']
})
export class MeetingActionsModalComponent implements OnInit, OnDestroy {
  private subscription!: Subscription;
  public sessionRemainingTime!: number;
  constructor() { }
  
  ngOnInit(): void {
   
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}




